import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L, { LatLngExpression } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import contactbg from './../../images/aboutus-bg-2.png';
import LocationIcon from './../../images/location.svg';

export const ContactScreen = () => {
  const { t } = useTranslation(); // Hook for translations
  const position: LatLngExpression = [47.55955719870742, 9.370466706515193];
  const customIcon = new L.Icon({
    iconUrl: LocationIcon,
    iconSize: [38, 38], // Size of the icon
    iconAnchor: [19, 38], // Anchor point of the icon
    popupAnchor: [0, -38], // Popup anchor point relative to the icon
  });

  return (
    <>
      <section
        className="w-full min-h-svh flex flex-col md:flex-row justify-center items-center px-smallPx md:px-mediumPx lg:px-[250px] py-20 bg-gradient-to-b from-black to-[#1E90AA] md:bg-none"
        style={{
          ...(window.innerWidth >= 768
            ? {
                backgroundImage: `url(${contactbg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'bottom',
              }
            : {}),
        }}
      >
        {/* Left Side - Contact Details */}
        <div className="w-[90%] h-fit md:w-1/2 flex flex-col justify-center text-black bg-white p-5 sm:p-10 rounded-tr-xl md:rounded-tr-none rounded-tl-xl md:rounded-bl-xl shadow-xl">
          <h1 className="text-xl md:text-3xl font-bold mb-4">
            {t('contactScreen.title')}
          </h1>
          <p className="text-md md:text-lg">{t('contactScreen.findUs')}</p>
          <p className="font-semibold">Waldmannstrasse 33, 8590 Romanshorn</p>
          <p className="font-semibold">Switzerland</p>

          <p className="mt-4">
            <span className="font-semibold">
              {t('contactScreen.phoneLabel1')}
            </span>{' '}
            <a href="tel:+41799219200" className="hover:underline">
              +41 79 921 92 00
            </a>
          </p>
          <p>
            <span className="font-semibold">
              {t('contactScreen.phoneLabel2')}
            </span>{' '}
            <a href="tel:+41788980284" className="hover:underline">
              +41 78 898 02 84
            </a>
          </p>
          <p className="mt-4">
            <span className="font-semibold">
              {t('contactScreen.emailLabel')}
            </span>{' '}
            <a
              href={`mailto:${t('contactScreen.email')}`}
              className="hover:underline"
            >
              {t('contactScreen.email')}
            </a>
          </p>

          <p className="mt-4">{t('contactScreen.availability')}</p>
        </div>

        {/* Right Side - Map */}
        <div className="w-full md:w-1/2 flex justify-center items-center z-10">
          <div className="w-[500px] h-[300px] md:w-full md:h-[400px] rounded-lg overflow-hidden shadow-xl">
            <MapContainer center={position} zoom={13} className="w-full h-full">
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <Marker position={position} icon={customIcon}>
                <Popup>
                  <a
                    href="https://www.google.com/maps/place/Waldmannstrasse+33,+8590+Romanshorn,+Switzerland/@47.55935,9.3702358,19.21z/data=!4m15!1m8!3m7!1s0x479afd69f3e814cd:0xaaea36db70311b42!2sWaldmannstrasse+33,+8590+Romanshorn,+Switzerland!3b1!8m2!3d47.5595299!4d9.3704648!16s%2Fg%2F11c2183_0k!3m5!1s0x479afd69f3e814cd:0xaaea36db70311b42!8m2!3d47.5595299!4d9.3704648!16s%2Fg%2F11c2183_0k?entry=ttu&g_ep=EgoyMDI1MDMxOS4yIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Waldmannstrasse 33, 8590 Romanshorn, Switzerland
                  </a>
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactScreen;
